<template>
  <section class="reg-2">
    <div class="container">
      <form action="reg-2" class="main-form needs-validation-reg-2" novalidate="">
        <img src="../../assets/img/reg-2-icon.png" class="float-right" alt="">
        <div class="col-6 head">
          <h2 class="title">Register</h2>
          <p class="text">Lorem ipsum dolor sit amet, consectetur adipisicing
            elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            Ut enim ad minim veniam, quis nostrud. </p>
          <h4 class="title">Before placing an order please fill survey below</h4>
        </div>

        <div class="questions">
          <ul class="list-group">

            <li class="list-group-item border-0">
              <div class="container">
                <h4 class="question-no">{{$t('surveys.question_no')}} 1</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[1].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[1].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
                <h5 class="question-text">Opis text odaj datę urodzenia</h5>
              </div>
              <div id="reg_birthdate" class="col-4">
                <div class="form-group">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_1_input"
                           id="question_1_input_1" v-model="survey_answers[1].answer_id" value="1">
                    <label class="custom-control-label" for="question_1_input_1">
                      {{$t('surveys.basic.questions[1].inputs[1].text')}}:
                    </label>
                    <datepicker placeholder="RRRR-MM-DD" format="yyyy-MM-dd"
                                v-model="survey_answers[1].answer_text"></datepicker>
                  </div>
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_1_input"
                           id="question_1_input_2" v-model="survey_answers[1].answer_id" value="2">
                    <label class="custom-control-label" for="question_1_input_2">
                      {{$t('surveys.basic.questions[1].inputs[2].text')}}
                    </label>
                  </div>
                </div>
              </div>
            </li>

            <li class="list-group-item border-0" v-if="survey_answers[1].answer_id == 2">
              <div class="container">
                <h4 class="question-no">{{$t('surveys.question_no')}} 1a</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[2].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[2].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="mb-4">
                    <input type="text" name="question_2_input_1"
                           id="question_2_input_1" v-model="survey_answers[2].answer_text">
                  </div>
                </div>
              </div>
            </li>

            <li class="list-group-item border-0">
              <div class="container">
                <h4 class="question-no">{{$t('surveys.question_no')}} 2</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[3].title')}}</h4>
                </div>
              </div>
              <div class="form-group">
                <div class="form-check">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" id="question_3_input_1"
                           v-model="survey_answers[3].answer_1_checked">
                    <label class="custom-control-label" for="question_3_input_1">{{$t('surveys.basic.questions[3].inputs[1].text')}}</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" id="question_3_input_2" value="2"
                           v-model="survey_answers[3].answer_2_checked">
                    <label class="custom-control-label" for="question_3_input_2">{{$t('surveys.basic.questions[3].inputs[2].text')}}</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" id="question_3_input_3" value="3"
                           v-model="survey_answers[3].answer_3_checked">
                    <label class="custom-control-label" for="question_3_input_3">{{$t('surveys.basic.questions[3].inputs[3].text')}}</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" id="question_3_input_4" value="4"
                           v-model="survey_answers[3].answer_4_checked">
                    <label class="custom-control-label" for="question_3_input_4">{{$t('surveys.basic.questions[3].inputs[4].text')}}</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" id="question_3_input_5" value="5"
                           v-model="survey_answers[3].answer_5_checked">
                    <label class="custom-control-label" for="question_3_input_5">{{$t('surveys.basic.questions[3].inputs[5].text')}}</label>
                  </div>
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" id="question_3_input_6" value="6"
                           v-model="survey_answers[3].answer_6_checked">
                    <label class="custom-control-label" for="question_3_input_6">{{$t('surveys.basic.questions[3].inputs[6].text')}}</label>
                  </div>
                </div>
              </div>


            </li>

            <li class="list-group-item border-0">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 3</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[4].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[4].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_4_input"
                           id="question_4_input_1" v-model="survey_answers[4].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_4_input_1">
                      {{$t('surveys.basic.questions[4].inputs[1].text')}}:
                    </label>
                    <input type="text" v-model="survey_answers[4].answer_text"/>
                  </div>

                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_4_input"
                           id="question_4_input_2" v-model="survey_answers[4].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_4_input_2">
                      {{$t('surveys.basic.questions[4].inputs[2].text')}}
                    </label>
                  </div>

                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_4_input"
                           id="question_4_input_3" v-model="survey_answers[4].answer_id" value="3"/>
                    <label class="custom-control-label" for="question_4_input_3">
                      {{$t('surveys.basic.questions[4].inputs[3].text')}}
                    </label>
                  </div>

                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_4_input"
                           id="question_4_input_4" v-model="survey_answers[4].answer_id" value="4"/>
                    <label class="custom-control-label" for="question_4_input_4">
                      {{$t('surveys.basic.questions[4].inputs[4].text')}}
                    </label>
                  </div>

                </div>
              </div>
            </li>

            <li class="list-group-item border-0 intro">
              <h4>{{$t('surveys.sex_section_info_title')}}</h4>
              <p>{{$t('surveys.sex_section_info_text')}}
              </p>
            </li>

            <li class="list-group-item border-0">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 4</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[5].title')}}</h4>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_5_input"
                           id="question_5_input_1" v-model="survey_answers[5].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_5_input_1">
                      {{$t('surveys.basic.questions[5].inputs[1].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_5_input"
                           id="question_5_input_2" v-model="survey_answers[5].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_5_input_2">
                      {{$t('surveys.basic.questions[5].inputs[2].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_5_input"
                           id="question_5_input_3" v-model="survey_answers[5].answer_id" value="3"/>
                    <label class="custom-control-label" for="question_5_input_3">
                      {{$t('surveys.basic.questions[5].inputs[3].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_5_input"
                           id="question_5_input_4" v-model="survey_answers[5].answer_id" value="4"/>
                    <label class="custom-control-label" for="question_5_input_4">
                      {{$t('surveys.basic.questions[5].inputs[4].text')}}
                    </label>
                  </div>

                </div>
              </div>
            </li>

            <li class="list-group-item border-0 intro">
              <h4>{{$t('surveys.family_origin_section_info_title')}}</h4>
              <p>{{$t('surveys.family_origin_section_info_text')}}
              </p>
            </li>

            <li class="list-group-item border-0">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 5</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[6].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[6].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_6_input"
                           id="question_6_input_1" v-model="survey_answers[6].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_6_input_1">
                      {{$t('surveys.basic.questions[6].inputs[1].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_6_input"
                           id="question_6_input_2" v-model="survey_answers[6].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_6_input_2">
                      {{$t('surveys.basic.questions[6].inputs[2].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_6_input"
                           id="question_6_input_3" v-model="survey_answers[6].answer_id" value="3"/>
                    <label class="custom-control-label" for="question_6_input_3">
                      {{$t('surveys.basic.questions[6].inputs[3].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_6_input"
                           id="question_6_input_4" v-model="survey_answers[6].answer_id" value="4"/>
                    <label class="custom-control-label" for="question_6_input_4">
                      {{$t('surveys.basic.questions[6].inputs[4].text')}}
                    </label>
                  </div>

                </div>
              </div>


            </li>

            <li class="list-group-item border-0 intro">
              <h4>{{$t('surveys.ancestry_section_info_title')}}</h4>
            </li>

            <li class="list-group-item border-0">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 6</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[7].title')}}</h4>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_7_input"
                           id="question_7_input_1" v-model="survey_answers[7].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_7_input_1">
                      {{$t('surveys.basic.questions[7].inputs[1].text')}}:
                    </label>
                    <select v-model="survey_answers[7].country_id">
                      <option disabled value="">Wybierz</option>
                      <option v-for="country in countries" v-bind:value="country.id">
                        {{country[localize('name')]}}
                      </option>
                    </select>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_7_input"
                           id="question_7_input_2" v-model="survey_answers[7].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_7_input_2">
                      {{$t('surveys.basic.questions[7].inputs[2].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_7_input"
                           id="question_7_input_3" v-model="survey_answers[3].answer_id" value="3"/>
                    <label class="custom-control-label" for="question_7_input_3">
                      {{$t('surveys.basic.questions[7].inputs[3].text')}}
                    </label>
                  </div>

                </div>
              </div>
            </li>

            <li class="list-group-item border-0">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 7</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[8].title')}}</h4>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_8_input"
                           id="question_8_input_1" v-model="survey_answers[8].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_8_input_1">
                      {{$t('surveys.basic.questions[8].inputs[1].text')}}:
                    </label>
                    <select v-model="survey_answers[8].country_id">
                      <option disabled value="">Wybierz</option>
                      <option v-for="country in countries" v-bind:value="country.id">
                        {{country[localize('name')]}}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_8_input"
                           id="question_8_input_2" v-model="survey_answers[8].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_8_input_2">
                      {{$t('surveys.basic.questions[8].inputs[2].text')}}
                    </label>
                  </div>

                </div>
              </div>
            </li>

            <li class="list-group-item border-0 intro" v-if="survey_answers[6].answer_id==1">
              <h4>{{$t('surveys.biological_family_section_info_title')}}</h4>
              <p>{{$t('surveys.biological_family_section_info_text')}}</p>
            </li>

            <li class="list-group-item border-0" v-if="survey_answers[6].answer_id==1">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 7a</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[9].title')}}</h4>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_9_input"
                           id="question_9_input_1" v-model="survey_answers[9].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_9_input_1">
                      {{$t('surveys.basic.questions[9].inputs[1].text')}}:
                    </label>
                    <select v-model="survey_answers[9].country_id">
                      <option disabled value="">Wybierz</option>
                      <option v-for="country in countries" v-bind:value="country.id">
                        {{country[localize('name')]}}
                      </option>
                    </select>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_9_input"
                           id="question_9_input_2" v-model="survey_answers[9].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_9_input_2">
                      {{$t('surveys.basic.questions[9].inputs[2].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_9_input"
                           id="question_9_input_3" v-model="survey_answers[9].answer_id" value="3"/>
                    <label class="custom-control-label" for="question_9_input_3">
                      {{$t('surveys.basic.questions[9].inputs[3].text')}}
                    </label>
                  </div>

                </div>
              </div>


            </li>

            <li class="list-group-item border-0" v-if="survey_answers[6].answer_id==1">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 7b</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[10].title')}}</h4>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_10_input"
                           id="question_10_input_1" v-model="survey_answers[10].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_10_input_1">
                      {{$t('surveys.basic.questions[10].inputs[1].text')}}:
                    </label>
                    <select v-model="survey_answers[10].country_id">
                      <option disabled value="">Wybierz</option>
                      <option v-for="country in countries" v-bind:value="country.id">
                        {{country[localize('name')]}}
                      </option>
                    </select>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_10_input"
                           id="question_10_input_2" v-model="survey_answers[10].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_10_input_2">
                      {{$t('surveys.basic.questions[10].inputs[2].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_10_input"
                           id="question_10_input_3" v-model="survey_answers[10].answer_id" value="3"/>
                    <label class="custom-control-label" for="question_10_input_3">
                      {{$t('surveys.basic.questions[10].inputs[3].text')}}
                    </label>
                  </div>

                </div>
              </div>


            </li>

            <li class="list-group-item border-0" style="margin-bottom: 15px">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 8</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[11].title')}}</h4>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-12" v-for="i in 19">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(11,i)"
                           v-model="survey_answers[11]['answer_'+i+'_checked']">
                    <label class="custom-control-label" v-bind:for="generateId(11,i)">{{$t('surveys.basic.questions[11].inputs['+i+'].text')}}</label>
                    <input v-if="[13,14,17].includes(i)" type="text"
                           v-model="survey_answers[11]['answer_'+i+'_text']"/>
                  </div>
                </div>
              </div>
            </li>

            <li class="list-group-item border-0 intro">
              <h4>{{$t('surveys.personal_health_section_info_title')}}</h4>
              <p>{{$t('surveys.personal_health_section_info_text')}}</p>
            </li>

            <li class="list-group-item border-0" style="margin-bottom: 15px">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 9</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[12].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[12].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-12">
                  <div class="custom-control custom-checkbox mb-4">
                    <span>{{$t('surveys.basic.questions[12].inputs[1].text')}}</span>
                    <input type="text" v-model="survey_answers[12].answer_text"/>
                  </div>
                </div>
              </div>
            </li>

            <li class="list-group-item border-0" style="margin-bottom: 15px">
              <div class="container">
                <h4 class="question-no">{{$t('surveys.question_no')}} 10</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[13].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[13].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-12">
                  <div class="custom-control custom-checkbox mb-4">
                    <span>{{$t('surveys.basic.questions[13].inputs[1].text')}}</span>
                    <input type="text" v-model="survey_answers[13].answer_text"/>
                  </div>
                </div>
              </div>
            </li>

            <li class="list-group-item border-0" style="margin-bottom: 15px">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 11</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[14].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[14].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_14_input"
                           id="question_14_input_1" v-model="survey_answers[14].answer_id" value="1"/>
                    <label class="custom-control-label" for="question_14_input_1">
                      {{$t('surveys.basic.questions[14].inputs[1].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_14_input"
                           id="question_14_input_2" v-model="survey_answers[14].answer_id" value="2"/>
                    <label class="custom-control-label" for="question_14_input_2">
                      {{$t('surveys.basic.questions[14].inputs[2].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_14_input"
                           id="question_14_input_3" v-model="survey_answers[14].answer_id" value="3"/>
                    <label class="custom-control-label" for="question_14_input_3">
                      {{$t('surveys.basic.questions[14].inputs[3].text')}}
                    </label>
                  </div>

                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-4">
                  <div class="custom-control custom-radio mb-4">
                    <input type="radio" class="custom-control-input" name="question_14_input"
                           id="question_14_input_4" v-model="survey_answers[14].answer_id" value="4"/>
                    <label class="custom-control-label" for="question_14_input_4">
                      {{$t('surveys.basic.questions[14].inputs[4].text')}}
                    </label>
                  </div>

                </div>
              </div>
            </li>

            <li class="list-group-item border-0" style="margin-bottom: 15px" v-if="survey_answers[14].answer_id==1">
              <div class="container">

                <h4 class="question-no">{{$t('surveys.question_no')}} 12</h4>
                <div class="d-flex flex-row">
                  <h4 class="question-title">{{$t('surveys.basic.questions[15].title')}}</h4>
                  <a class="button btn-i" data-toggle="popover"
                     :data-content="$t('surveys.basic.questions[15].info')"
                     data-original-title="" title="">
                    <img alt="Arrow Down Icon" src="../../assets/img/info-logo.png"></a>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[1].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 23">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i)"
                           v-model="survey_answers[15].answer_checked[i]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i)">{{$t('surveys.basic.questions[15].categories[1].inputs['+i+'].title')}}</label>
                    <input v-if="i == 22" type="text" v-model="survey_answers[15].answer_text[i]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[2].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 5">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+23)"
                           v-model="survey_answers[15].answer_checked[i+23]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+23)">{{$t('surveys.basic.questions[15].categories[2].inputs['+(i+23)+'].title')}}</label>
                    <input v-if="(i+23) == 27" type="text"
                           v-model="survey_answers[15].answer_text[i+23]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[3].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 10">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+28)"
                           v-model="survey_answers[15].answer_checked[i+28]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+28)">{{$t('surveys.basic.questions[15].categories[3].inputs['+(i+28)+'].title')}}</label>
                    <input v-if="(i+28) == 37" type="text"
                           v-model="survey_answers[15].answer_text[i+28]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[4].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 10">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+38)"
                           v-model="survey_answers[15].answer_checked[i+38]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+38)">{{$t('surveys.basic.questions[15].categories[4].inputs['+(i+38)+'].title')}}</label>
                    <input v-if="((i+38) == 41) || ((i+38) == 47)" type="text"
                           v-model="survey_answers[15].answer_text[i+38]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[5].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 5">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+48)"
                           v-model="survey_answers[15].answer_checked[i+48]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+48)">{{$t('surveys.basic.questions[15].categories[5].inputs['+(i+48)+'].title')}}</label>
                    <input v-if="((i+48) == 50) || ((i+48) == 52)" type="text"
                           v-model="survey_answers[15].answer_text[i+48]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[6].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 7">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+53)"
                           v-model="survey_answers[15].answer_checked[i+53]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+53)">{{$t('surveys.basic.questions[15].categories[6].inputs['+(i+53)+'].title')}}</label>
                    <input v-if="((i+53) == 55) || ((i+53) == 59)" type="text"
                           v-model="survey_answers[15].answer_text[i+53]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[7].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 9">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+60)"
                           v-model="survey_answers[15].answer_checked[i+60]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+60)">{{$t('surveys.basic.questions[15].categories[7].inputs['+(i+60)+'].title')}}</label>
                    <input v-if="(i+60) == 68" type="text"
                           v-model="survey_answers[15].answer_text[i+60]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[8].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 14">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+69)"
                           v-model="survey_answers[15].answer_checked[i+69]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+69)">{{$t('surveys.basic.questions[15].categories[8].inputs['+(i+69)+'].title')}}</label>
                    <input v-if="(i+69) == 82" type="text"
                           v-model="survey_answers[15].answer_text[i+69]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[9].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 7">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+83)"
                           v-model="survey_answers[15].answer_checked[i+83]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+83)">{{$t('surveys.basic.questions[15].categories[9].inputs['+(i+83)+'].title')}}</label>
                    <input v-if="(i+83) == 89" type="text"
                           v-model="survey_answers[15].answer_text[i+83]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[10].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 2">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+90)"
                           v-model="survey_answers[15].answer_checked[i+90]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+90)">{{$t('surveys.basic.questions[15].categories[10].inputs['+(i+90)+'].title')}}</label>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[11].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 11">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+92)"
                           v-model="survey_answers[15].answer_checked[i+92]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+92)">{{$t('surveys.basic.questions[15].categories[11].inputs['+(i+92)+'].title')}}</label>
                    <input v-if="(i+92) == 102" type="text"
                           v-model="survey_answers[15].answer_text[i+92]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[12].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 4">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+103)"
                           v-model="survey_answers[15].answer_checked[i+103]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+103)">{{$t('surveys.basic.questions[15].categories[12].inputs['+(i+103)+'].title')}}</label>
                    <input v-if="((i+103) == 106) || ((i+103) == 107)" type="text"
                           v-model="survey_answers[15].answer_text[i+103]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[13].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 4">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+107)"
                           v-model="survey_answers[15].answer_checked[i+107]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+107)">{{$t('surveys.basic.questions[15].categories[13].inputs['+(i+107)+'].title')}}</label>
                    <input v-if="(i+107) == 110" type="text"
                           v-model="survey_answers[15].answer_text[i+107]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[14].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 5">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+111)"
                           v-model="survey_answers[15].answer_checked[i+111]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+111)">{{$t('surveys.basic.questions[15].categories[14].inputs['+(i+111)+'].title')}}</label>
                    <input v-if="(i+111) == 115" type="text"
                           v-model="survey_answers[15].answer_text[i+111]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[15].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 6">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+116)"
                           v-model="survey_answers[15].answer_checked[i+116]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+116)">{{$t('surveys.basic.questions[15].categories[15].inputs['+(i+116)+'].title')}}</label>
                    <input v-if="(i+116) == 121" type="text"
                           v-model="survey_answers[15].answer_text[i+116]"/>
                  </div>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-12">
                  <h2>{{$t('surveys.basic.questions[15].categories[16].title')}}</h2>
                </div>
                <div class="col-sm-12" v-for="i in 7">
                  <div class="custom-control custom-checkbox mb-4">
                    <input type="checkbox" class="custom-control-input" v-bind:id="generateId(15,i+122)"
                           v-model="survey_answers[15].answer_checked[i+122]">
                    <label class="custom-control-label" v-bind:for="generateId(15,i+122)">{{$t('surveys.basic.questions[15].categories[16].inputs['+(i+122)+'].title')}}</label>
                    <input v-if="((i+122) == 123) || ((i+122) == 128)" type="text"
                           v-model="survey_answers[15].answer_text[i+122]"/>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <div class="row text-center">
          <div class="col-md-12">
            <a href="/#/todo" @click="goBack" class="btn btn-dark" data-toggle="modal"
               data-target="#cancelRegister">Anuluj</a>
            <a href="#" class="btn btn-main" @click="saveSurvey(1)">Zapisz ankietę i przejdź dalej</a>
          </div>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
  import Datepicker from 'vuejs-datepicker';
  import {mapGetters} from 'vuex';
  import translatorMixin from '../../mixins/translatorMixin';
  import {
    FETCH_COUNTRIES,
    FETCH_SURVEY_ANSWERS,
    SAVE_SURVEY_ANSWERS,
  } from '../../store/actions';

  export default {
    name: "SurveyBasic",
    components: {Datepicker},
    mixins: [translatorMixin],
    props: ['survey_hash'],
    data: function () {
      return {
        survey_answers: {
          1: {
            answer_text: '',
            answer_id: ''
          },
          2: {
            answer_text: ''
          },
          3: {
            answer_1_checked: false,
            answer_2_checked: false,
            answer_3_checked: false,
            answer_4_checked: false,
            answer_5_checked: false,
            answer_6_checked: false,
          },
          4: {
            answer_text: '',
            answer_id: ''
          },
          5: {
            answer_id: ''
          },
          6: {
            answer_id: ''
          },
          7: {
            answer_id: '',
            country_id: ''
          },
          8: {
            answer_id: '',
            country_id: ''
          },
          9: {
            answer_id: '',
            country_id: ''
          },
          10: {
            answer_id: '',
            country_id: ''
          },
          11: {
            answer_1_checked: false,
            answer_2_checked: false,
            answer_3_checked: false,
            answer_4_checked: false,
            answer_5_checked: false,
            answer_6_checked: false,
            answer_7_checked: false,
            answer_8_checked: false,
            answer_9_checked: false,
            answer_10_checked: false,
            answer_11_checked: false,
            answer_12_checked: false,
            answer_13_checked: false,
            answer_14_checked: false,
            answer_15_checked: false,
            answer_16_checked: false,
            answer_17_checked: false,
            answer_18_checked: false,
            answer_19_checked: false,
            answer_13_text: '',
            answer_14_text: '',
            answer_17_text: '',
          },
          12: {
            answer_text: ''
          },
          13: {
            answer_text: ''
          },
          14: {
            answer_id: ''
          },
          15: {
            answer_checked: [],
            answer_text: []
          }
        },
      }
    },
    computed: {
      ...mapGetters(['countries'])
    },
    mounted: function () {
      this.$store.dispatch(FETCH_SURVEY_ANSWERS, {'id': this.survey_hash}).then(
        response => {
          this.survey_answers = JSON.parse(response.data.survey_answers);
        }
      ).catch(error => {
        console.log(error);
      });
      this.$store.dispatch(FETCH_COUNTRIES);
    },
    methods: {
      generateId: function (question_id, input_id) {
        return 'question_' + question_id + '_input_' + input_id;
      },
      saveSurvey: function (survey_id) {
        this.$store.dispatch(SAVE_SURVEY_ANSWERS, {
          'survey_hash': this.survey_hash,
          'survey_answers': JSON.stringify(this.survey_answers),
        });
        this.$emit('survey-saved');
      },
      goBack: function () {
        this.$emit('go-back');
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/surveys/SurveyBasic.vue